<p-tabs value="{{ activeTabIndex }}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <app-custom-button [title]="'Sincronizar'" [label]="'Sincronizar'" [severity]="'success'" [width]="'6.5rem'"
      [icon]="'pi pi-sync'" (onClick)="newElectronicInvoiceInterfaceEntry()" [ngClass]="'widthBtns'"
      [variant]="undefined"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'electronic-invoice-interface'"
        (onRecoverData)="getElectronicInvoiceInterfaceForGeneralConsultation()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-indicators [charts]="indicatorCharts" [loading]="loadingIndicators"></app-custom-indicators>
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'electronic-invoice-interface'"
        [rowClass]="rejectedDianRowClass" (onRecoverData)="getColumnsForDetailConsultation()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)" (onReload)="getIndicatorsForGeneralConsultation()"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>